module.exports = __webpack_public_path__ + "static/img/artificial-photography-vB5qtt8X4NA-unsplash_thumb.f38a4cf.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/ads/standard_bg/artificial-photography-vB5qtt8X4NA-unsplash_thumb.png
// module id = a4fF
// module chunks = 4